import React from 'react'
import classNames from 'classnames'
import { ColorType, FloatType } from './Control';

export type NotificationProps = React.PropsWithChildren<{
	onDismiss?: () => void
	colorType?: ColorType
	isLight?: boolean
	float?: FloatType
}>

export function Notification(props: NotificationProps) {
	const className = classNames('notification', props.colorType && `is-${props.colorType}`, props.isLight && `is-light`, props.float && `is-pulled-${props.float}`)
	const dismissButton = props.onDismiss ? <button className='delete' onClick={props.onDismiss}></button> : null

	return (
		<div className={className}>
			{dismissButton}
			{props.children}
		</div>
	)
}